import WebFont from 'webfontloader/webfontloader';

WebFont.load({
  google: {
    families: [
      "Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic",
      "Playfair Display:regular,italic,700,700italic,900,900italic",
      "Lora:regular,italic,700,700italic",
      "Muli:200,200italic,300,300italic,regular,italic,600,600italic,700,700italic,800,800italic,900,900italic",
      "Work Sans"
    ]
  }
});
